import React from 'react';

export function LoadingSpinner({ style }) {
  return (
    <div className="ct-loading-spinner" style={style}>
      <div className="circles">
        <div className="loader">
          <span />
        </div>
      </div>
    </div>
  );
}
